import { Component, Input } from '@angular/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';

@Component({
  selector: 'app-textbox-cell',
  template: `
<mat-form-field appearance="outline">
<mat-label>{{ field.key | translate }}</mat-label>
<input matInput
  ignoreInputScroll
  type="{{field.controlType === 'numeric' ? 'number' : 'text'}}"
  autocomplete="off"
  [formControl]="field.control"
  [transform]="toDbModel.bind(this)"
  placeholder="{{ field.key | translate }}" />
</mat-form-field>
`,
  styleUrls: ['./textbox-cell.component.scss'],
})
export class TextboxCellComponent {
  @Input() public field!: ConstrainedField;

  public toDbModel(value: string | number | null): string | number {
    if (this.field.controlType == "numeric") {
      return typeof (value) == "number" ? value : parseFloat(value);
    }
    else {
      return value;
    }
  }
}
